<div class="container">
	<div class="data">
		<div class="name" title="{{ room.id }}">
			{{ name }}
			o: {{ occupancy }}
			<i class="fa fa-circle-info" matTooltipPosition="above" matTooltip="{{ room.description }}"></i>
		</div>

		<div class="board" [ngStyle]="room.styles">
			<ng-container *ngIf="_service.reservationMove">
				<div class="moveButton" (click)="reservationMoveHere(room)">
					<div class="stateOverlay" [ngStyle]="_service.divStyles"></div>
				</div>
			</ng-container>
			<app-accommodations-products-rooms-availabilities
				*ngFor="let availability of room.availabilities"
				[availability]="availability"
			></app-accommodations-products-rooms-availabilities>
		</div>
	</div>
	<ng-container *ngIf="_service.show.subrooms && room.roomSlaves && room.roomSlaves.length">
		<app-accommodations-products-rooms
			*ngFor="let roomSlave of room.roomSlaves"
			[room]="roomSlave"
			[name]="roomSlave.roomType.code"
		></app-accommodations-products-rooms>
		<div class="separator"></div>
	</ng-container>
</div>
